import { render, staticRenderFns } from "./linkDialog.vue?vue&type=template&id=1ff4a3dc&scoped=true&"
import script from "./linkDialog.vue?vue&type=script&lang=js&"
export * from "./linkDialog.vue?vue&type=script&lang=js&"
import style0 from "./linkDialog.vue?vue&type=style&index=0&id=1ff4a3dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff4a3dc",
  null
  
)

export default component.exports